var DEFAULT_BG_COLOR = {
  cash: "#fdefeb",
  finance: "#fbfbfb"
};
var DEFAULT_TXT_COLOR = "#ec6234";

/** Shared fallback so CardCampaignLabel/PostDetailsCampaignLabel/PrecheckoutCampaignLabel never diverge on defaults. */
export var getCampaignColors = function getCampaignColors(campaign, type) {
  return {
    bgColor: campaign.bgColor || DEFAULT_BG_COLOR[type],
    txtColor: campaign.txtColor || DEFAULT_TXT_COLOR
  };
};

/**
 * Reads the `campaign_tags` array confirmed by backend in SE-12996 (comment 89984):
 * `post/view-online`, `/index`, `/similar`, `/recommended`, `list-favourite` all return
 *   campaign_tags: [{ type: "cash"|"finance", lable, icon, bg_color, txt_color }]
 * (note: `lable` is the backend's actual field name, not a typo on our side).
 * Priority resolution (picking the winning theme when several match) happens server-side —
 * there's at most one "cash" and one "finance" tag in this array.
 */
export var normalizeCampaigns = function normalizeCampaigns(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map(function (tag) {
    if (!tag || typeof tag !== "object") return null;
    var _ref = tag,
      type = _ref.type,
      lable = _ref.lable,
      icon = _ref.icon,
      bg_color = _ref.bg_color,
      txt_color = _ref.txt_color;
    if (!lable || typeof lable !== "string") return null;
    if (type !== "cash" && type !== "finance") return null;
    return {
      text: lable,
      type: type,
      icon: typeof icon === "string" ? icon : undefined,
      bgColor: typeof bg_color === "string" ? bg_color : undefined,
      txtColor: typeof txt_color === "string" ? txt_color : undefined
    };
  }).filter(function (tag) {
    return tag !== null;
  });
};